var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.genre)?_c('FullView',{attrs:{"type":"genre","id":_vm.genre.id,"cover":_vm.genre.cover,"label":_vm.$l10n("GENRE").toLowerCase(),"title":_vm.genre.name || _vm.$l10n("NO_NAME"),"show-controls":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }